import { GroupedQuickFiltersProps } from './GroupedQuickFilters.typed';

import { Fragment } from 'react';
import { GroupedQuickFilter } from '../GroupedQuickFilter/GroupedQuickFilter';
import { shouldApplyGapBetweenCheckboxFilters } from '../../../../../features/filters/helpers/filterUtils';

const GroupedQuickFilters = (props: GroupedQuickFiltersProps) => {
  const {
    sectionName,
    locationConfiguration,
    makeModelConfiguration,
    validPriceConfiguration,
    subfilters,
  } = props;

  return (
    <>
      {subfilters?.map((subfilter, index) => {
        const nextSubfilter = subfilters[index + 1];
        const isLastItem = index === subfilters.length - 1;
        const shouldHaveGap = shouldApplyGapBetweenCheckboxFilters(
          subfilter,
          nextSubfilter,
          isLastItem,
        );

        return (
          <Fragment key={`subfilter-${subfilter.name}-${index}`}>
            <GroupedQuickFilter
              subfilter={subfilter}
              sectionName={sectionName}
              locationConfiguration={locationConfiguration}
              makeModelConfiguration={makeModelConfiguration}
              validPriceConfiguration={validPriceConfiguration}
              gap={shouldHaveGap ? 'M16' : undefined}
            />
          </Fragment>
        );
      })}
    </>
  );
};

export { GroupedQuickFilters };
